import { useEffect, useContext, useState, useRef } from "react";
import { DataContext } from "../../../context/DataContext";
import feather from "feather-icons";
import { petitions } from "../../../api/calls";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import Select from "react-select";
import customStyles from "../../../frontend/styles/select";
import customStyles_v2 from "../../../frontend/styles/select_v2";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import productEmpty_light from "../../../frontend/assets/img/spot-illustrations/35.png";
import productEmpty_dark from "../../../frontend/assets/img/spot-illustrations/35_2.png";
import {
  EditableCellNumber,
  EditableCellTextarea,
} from "../../componentsTools/EditableCell";
import Table from "../../componentsTable/TableVenta";
import {
  deleteIGVDefault,
  deleteProductDefault,
  addProduct,
  setValueTableDefault,
  calculateAmountsVenta,
} from "../../../utils/helpers";

export default function EditPrice() {
  const { session, idEmpresa, user, empresa } = useContext(DataContext);
  const [obj, setCotizacion] = useState({});
  const location = useLocation();
  const idCotizacion = location.state?.idCotizacion;
  const main = location.state?.main;
  const [type, setType] = useState("P");
  const [pservicio, setPservicio] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [producto, setProducto] = useState(null);
  const [cantidad, setCantidad] = useState("");
  const [precio, setPrecio] = useState("");
  const [tpago, setTpago] = useState([]);
  const [mPago, seMpago] = useState([]);
  const [moneda, setMoneda] = useState([]);
  const [igv, setIgv] = useState(true);
  const [descuento, setDescuento] = useState("");

  const navigate = useNavigate();

  //DETALLE
  const [data, setData] = useState([]);

  const modalConfiguracion = useRef(null);
  const modalClonar = useRef(null);
  const [docType, setDocType] = useState("venta");

  //STADISTICS
  const stadicts = (() => {
    const IGV_RATE = 0.18;

    // Calcular afecto en base imponible (sin IGV)
    const impAfecto = data.reduce(
      (acc, item) =>
        item.igv === "S" ? acc + item.importe / (1 + IGV_RATE) : acc,
      0
    );

    const impInafecto = data.reduce(
      (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
      0
    );

    const dsctTasa = Number(descuento) || 0;

    // Descuento solo sobre lo afecto
    const dsctImp = impAfecto * (dsctTasa / 100);

    const baseNeta = impAfecto - dsctImp;
    const igv = baseNeta * IGV_RATE;

    return {
      subtotal: baseNeta + impInafecto, // sin IGV
      igv,
      total: baseNeta + impInafecto + igv,
      descuento: dsctImp,
    };
  })();

  //FORMULARIO MAESTRO
  const form1 = useForm({
    defaultValues: {
      tipComprobante: "CO",
      serComprobante: "C001",
      fecOperacion: new Date().toLocaleDateString("en-CA", {
        timeZone: "America/Lima",
      }),
      fecVencimiento: "",
      idMoneda: "1",
      impAfecto: 0.0,
      impInafecto: 0.0,
      _base: 0,
      igv: 18.0,
      impTotal: 0.0,
      dsctTasa01: 0.0,
      dsctTasa02: 0.0,
      dsctImp01: 0.0,
      dsctImp02: 0.0,
      impDsctoTotal: 0.0,
      idcont: "",
      idTPago: "",
      numItems: 0,
      idUsuario: user?.idUsuario || "",
      idMedioPago: "",
      impuesto: 0,
      tcambio: 0,
      obs: "PROFORMA",
      atte: "",
      tiempoEntrega: "",
      garantia: "",
    },
  });

  const setValueTable = (row) => {
    setValueTableDefault(row, setData);
  };

  const columns = [
    {
      header: (
        <th
          className="sort white-space-nowrap align-middle"
          scope="col"
          style={{ minWidth: "200px" }}
        >
          PRODUCTO / SERVICIO
        </th>
      ),
      accessorKey: "nombreAlternativo",
      cell: ({ row }) => (
        <EditableCellTextarea
          value={row.original.nombreAlternativo}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="nombreAlternativo"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "150px" }}
        >
          CANTIDAD
        </th>
      ),
      accessorKey: "cantidad",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.cantidad}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="cantidad"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "300px" }}
        >
          PRECIO U.
        </th>
      ),
      accessorKey: "precio",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.precio}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="precio"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          DESCUENTO
        </th>
      ),
      accessorKey: "dscto01",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.dscto01}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="dscto01"
          clase="badge badge-phoenix fs-10 badge-phoenix-info rounded-4"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          SUB TOTAL
        </th>
      ),
      accessorKey: "subtotal",
      cell: ({ row }) => (
        <td className="color align-middle white-space-nowrap text-body py-0 text-end">
          {parseFloat(row.original.subtotal).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "250px" }}
        >
          TOTAL
        </th>
      ),
      accessorKey: "importe",
      cell: ({ row }) => (
        <td className="total align-middle fw-bold text-body-highlight text-end py-0">
          {parseFloat(row.original.importe).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "10px" }}
        ></th>
      ),
      accessorKey: "acciones",
      cell: ({ row }) => {
        const igvColor =
          row.original.igv === "S" ? "text-primary" : "text-secondary";
        return (
          <td className="total align-middle fw-bold text-body-highlight text-end py-1">
            <div className="row justify-content-end g-0">
              <div
                className="col-auto"
                onClick={() => {
                  deleteProduct(row.index);
                }}
              >
                <span
                  className="text-danger uil-trash-alt"
                  title="Eliminar"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
              <div
                className="col-auto"
                onClick={() => {
                  deleteIGV(row.index);
                }}
              >
                <span
                  className={`${igvColor} uil-file-upload-alt`}
                  title="IGV"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
            </div>
          </td>
        );
      },
    },
  ];

  const deleteIGV = (rowIndex) => {
    deleteIGVDefault(rowIndex, setData);
  };

  const deleteProduct = (index) => {
    deleteProductDefault(index, setData);
  };

  useEffect(() => {
    feather.replace();
  }, []);

  useEffect(() => {
    const axiosProducts = async () => {
      setData([]);
      const response = await petitions.getProductsType(
        idEmpresa(),
        session().token,
        type
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idProducto,
          label: e.nombre,
          pventa: e.pVenta,
        }));
        setPservicio(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    axiosProducts();
  }, [idEmpresa, session, type]);

  useEffect(() => {
    const fetchClientes = async () => {
      const obj = session();
      const response = await petitions.getClientesSelect(
        idEmpresa(),
        obj.token
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setClientes(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchClientes();
  }, [idEmpresa, session]);

  useEffect(() => {
    const getMedPago = async () => {
      const response = await petitions.getMedPagos(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        var array = [];
        response.data.forEach((e) => {
          array.push({ value: e.idMedPago, label: e.descripcion });
        });
        seMpago(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };
    getMedPago();
  }, [form1, idEmpresa, session]);

  useEffect(() => {
    const fetchTPago = async () => {
      const response = await petitions.getTPago(idEmpresa(), session().token);
      if (response.status === "success") {
        var array = [];
        response.data.forEach((e) => {
          if (e.estado === "S") {
            array.push({ value: e.idTpago, label: e.descripcion });
          }
        });
        setTpago(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPago();
  }, [form1, idEmpresa, session]);

  useEffect(() => {
    const fetchMoneda = async () => {
      const response = await petitions.getMoneda(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMoneda.toString(),
          label: e.simbolo,
        }));
        setMoneda(array);

        form1.setValue(
          "idMoneda",
          obj?.cotizacion?.idMoneda?.toString() ?? "1",
          { shouldValidate: true }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMoneda();
  }, [form1, session, idEmpresa, obj?.cotizacion?.idMoneda]);

  useEffect(() => {
    const fetchCotizacion = async () => {
      setData([]);
      const response = await petitions.getCotizacion(
        idEmpresa(),
        session().token,
        idCotizacion
      );

      if (response.status === "success") {
        setCotizacion(response.data);
        setDescuento(response.data.cotizacion.dsctoTasa01);

        response?.data?.detalle.forEach((item) => {
          setData((prevData) => [
            ...prevData,
            {
              idPServicio: item.idPServicio,
              cantidad: item.cantidad,
              precio: item.precio,
              igv: item.igv,
              dscto01: item.dscto01,
              dscto02: item.dscto02,
              subtotal: item.cantidad * item.precio,
              dsctoImporte: item.dsctoImporte,
              importe: item.importe,
              idUsuario: user?.idUsuario || "",
              nombreAlternativo: item.name,
            },
          ]);
        });

        form1.setValue("tipo", response?.data?.cotizacion?.obs ?? "", {
          shouldValidate: true,
        });
        form1.setValue("idcont", response?.data?.cotizacion?.idcont ?? "", {
          shouldValidate: true,
        });
        form1.setValue(
          "garantia",
          response?.data?.cotizacion?.condiciones ?? "",
          { shouldValidate: true }
        );
        form1.setValue(
          "tiempoEntrega",
          response?.data?.cotizacion?.tiempoEntrega ?? "",
          { shouldValidate: true }
        );
        form1.setValue(
          "fecVencimiento",
          response?.data?.cotizacion?.fVencimiento.split("T")[0] ?? "",
          { shouldValidate: true }
        );
        form1.setValue("idMoneda", response?.data?.cotizacion?.idMoneda ?? "", {
          shouldValidate: true,
        });
        form1.setValue("idTPago", response?.data?.cotizacion?.idTPago ?? "", {
          shouldValidate: true,
        });
        form1.setValue(
          "idMedioPago",
          response?.data?.cotizacion?.idMPago ?? "",
          { shouldValidate: true }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchCotizacion();
  }, [form1, idCotizacion, idEmpresa, session, user?.idUsuario]);

  const updateCotizacion = form1.handleSubmit(async (form) => {
    const maestro = calculateAmountsVenta(form, data, descuento);
    maestro.idVenta = obj?.cotizacion?.idVenta || "";

    var join = {
      cotizacion: maestro,
      detalleVenta: data,
    };

    toast("¿Estas seguro(a) de actualizar esta cotización?", {
      action: {
        label: "Confirmar",
        onClick: async () => {
          const response = await petitions.updateCotizacion(
            idEmpresa(),
            session().token,
            join
          );
          if (response.status === "success") {
            toast.success(
              "Cotización " +
                obj?.cotizacion?.serComprobante +
                "-" +
                obj?.cotizacion?.nroComprobante +
                " actualizada correctamente"
            );
            form1.reset();
            setData([]);
            navigate("/main/VerCotizacion", { replace: true });
          } else {
            var msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        },
      },
    });
  });

  const clone = async () => {
    obj.status = true; // indicar que es clonado
    const { idMPago, idTPago, ...rest } = obj.cotizacion;

    obj.venta = {
      ...rest,
      idMedioPago: idMPago,
      idTipoPago: idTPago,
    };

    delete obj.cotizacion;

    const modalInstance = window.bootstrap.Modal.getInstance(
      modalClonar.current
    );
    modalInstance.hide();

    let url = "";
    switch (docType) {
      case "venta":
        url = "EmitirComprobantes";
        obj.venta.tipComprobante = "01";
        break;
      case "cotizacion":
        url = "EmitirCotizacion";
        break;
      case "guiaremision":
        obj.venta.tipComprobante = "";
        url = "NuevaES";
        obj.type = "S";
        break;
    }

    obj.detalle = obj.detalle.map((item) => ({
      ...item,
      idPServicio: item.idPServicio ?? "",
      cantidad: item.cantidad ?? 0,
      precio: item.precio ?? 0,
      igv: item.igv ?? "N",
      dscto01: item.dscto01 ?? 0,
      dscto02: item.dscto02 ?? 0,
      subtotal: (item.cantidad * item.precio).toFixed(2),
      dsctoImporte: item.dsctoImporte ?? 0,
      importe: item.importe ?? 0,
      idUsuario: session().idUsuario,
      nombreAlternativo: item.name || "",
    }));

    navigate("/main/" + url, {
      replace: true,
      state: { body: obj },
    });
  };

  return (
    <>
      <div className="row justify-content-between align-items-end g-3 mb-4">
        <div className="col-12 col-sm-auto col-xl-8">
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <button
              className="px-2 py-1 pt-2 bg-primary-subtle rounded-3 border-0"
              type="button"
              onClick={() => {
                navigate(main, { replace: true });
              }}
            >
              <span className="fas fa-long-arrow-alt-left"></span>
            </button>
            <h2 className="mb-0">Editar cotización</h2>
            <h3 className="text-primary mt-2">
              <span className="bg-body pe-2">
                {obj?.cotizacion?.tipComprobante}-
                {obj?.cotizacion?.serComprobante}-
                {obj?.cotizacion?.nroComprobante}
              </span>
            </h3>
          </div>
        </div>
        <div className="col-12 col-sm-auto col-xl-4">
          <div className="d-flex">
            <button
              className="btn px-3 btn-phoenix-secondary px-3 me-1 rounded-4"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
              onClick={() => {
                const modal = new window.bootstrap.Modal(
                  modalConfiguracion.current
                );
                modal.show();
              }}
            >
              <span
                className="fas fa-cog text-primary"
                data-fa-transform="down-3"
              ></span>
            </button>
            <button
              className="btn px-3 btn-phoenix-primary px-3 me-1 rounded-4"
              type="button"
              title="Clonar"
              onClick={() => {
                const modal = new window.bootstrap.Modal(modalClonar.current);
                modal.show();
              }}
            >
              <span className="far fa-clone" data-fa-transform="down-3"></span>
            </button>
            <button
              type="button"
              title="Limpiar"
              className="btn px-3 btn-phoenix-secondary px-3 me-1 rounded-4"
              onClick={() => {
                form1.reset();
                setData([]);
                setDescuento("");
              }}
            >
              <span className="fas fa-undo" data-fa-transform="down-3"></span>
            </button>
            <form onSubmit={updateCotizacion}>
              <button
                className="btn btn-primary px-5 w-100 text-nowrap rounded-4"
                href="event-detail.html"
                disabled={data.length === 0}
              >
                Actualizar
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="row g-5">
        <div className="col-xl-8">
          <div className="row gx-3 gy-4 mb-4">
            <div className="row g-2">
              <div className="col-md-2">
                <div className="d-flex">
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "P" ? "active" : ""
                    }`}
                    title="Producto"
                    onClick={() => {
                      setProducto(null);
                      setType("P");
                    }}
                  >
                    {" "}
                    <span className="fas fa-book"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "S" ? "active" : ""
                    }`}
                    title="Servicio"
                    onClick={() => {
                      setProducto(null);
                      setType("S");
                    }}
                  >
                    {" "}
                    <span className="fas fa-wrench"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg rounded-3 ${
                      type === "Q" ? "active" : ""
                    }`}
                    title="Paquete"
                    onClick={() => {
                      setProducto(null);
                      setType("Q");
                    }}
                  >
                    <span className="fas fa-box-open"></span>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-5">
                <Select
                  className="mb-0 mi-select"
                  classNamePrefix="rs"
                  options={pservicio}
                  value={producto}
                  styles={customStyles_v2}
                  placeholder={
                    type === "P"
                      ? "Buscar Producto"
                      : type === "S"
                      ? "Buscar Servicio"
                      : type === "Q"
                      ? "Buscar Paquete"
                      : "Buscar..."
                  }
                  isLoading={false}
                  isClearable={true}
                  onChange={(event) => {
                    if (!event) {
                      setProducto(null);
                      setCantidad(0);
                      setPrecio(0);
                    } else {
                      setProducto(event);
                      setCantidad(1);
                      setPrecio(event.pventa);
                    }
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-email"
                  id="add-property-wizardwizard-email"
                  placeholder="Cantidad"
                  value={cantidad}
                  onChange={(event) => {
                    setCantidad(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-phone"
                  id="add-property-wizardwizard-phone"
                  placeholder="Precio"
                  value={precio}
                  onChange={(event) => {
                    setPrecio(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-1">
                <button
                  className="btn btn-phoenix-secondary px-3 me-2 rounded-4"
                  type="button"
                  data-boundary="window"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-reference="parent"
                  disabled={!producto || Object.keys(producto).length === 0}
                  onClick={() => {
                    if (empresa.validarAlmacen === "S" && producto.stock <= 0) {
                      toast.warning(
                        "No hay stock disponible para " + producto.label
                      );
                      return;
                    }
                    if (
                      empresa.validarAlmacen === "S" &&
                      producto.stock < cantidad
                    ) {
                      toast.warning(
                        "Cantidad supera el stock disponible (" +
                          producto.stock +
                          ")"
                      );
                      return;
                    }
                    if (empresa.validarAlmacen === "S" && cantidad <= 0) {
                      toast.warning("La cantidad debe ser mayor a 0");
                      return;
                    }

                    addProduct(
                      producto,
                      cantidad,
                      precio,
                      igv,
                      setData,
                      setProducto,
                      setCantidad,
                      setPrecio,
                      user?.idUsuario
                    );
                  }}
                >
                  <span
                    className="fas fa-plus text-success"
                    data-fa-transform="down-2"
                  ></span>
                </button>
              </div>
            </div>
          </div>
          <div className="row g-5 gy-7">
            <div className="col-12 col-xl-12 col-xxl-12">
              <div
                id="orderTable"
                data-list='{"valueNames":["products","color","size","price","quantity","total"],"page":10}'
                className="mb-3"
              >
                <div className="table-responsive scrollbar">
                  <Table data={data} columns={columns} />
                </div>
              </div>
              {data.length > 0 ? (
                <>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <span className="badge badge-phoenix fs-10 badge-phoenix-secondary mt-1 mb-2 me-4 rounded-3 border-0 shadow-sm">
                      <span className="far fa-lightbulb me-1"></span> El
                      descuento afecta solo a operaciones gravadas
                    </span>
                    <p className="text-body-emphasis  lh-sm mb-0 me-5 mt-1">
                      Descuentos (%)
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2 mt-1">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <input
                      type="number"
                      placeholder="Descuento"
                      className="form-control form-control-sm text-star rounded-4 border-0 shadow-sm"
                      style={{ minWidth: "130px", maxWidth: "120px" }}
                      value={
                        !data.some((item) => item.igv === "S") ? 0 : descuento
                      }
                      onChange={(e) => setDescuento(e.target.value)}
                      disabled={!data.some((item) => item.igv === "S")}
                    />
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">
                      Subtotal
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.subtotal).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">IGV</p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.igv).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis fw-semibold lh-sm mb-0 me-5">
                      Total
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <p
                      className="text-body-emphasis fw-bold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.total).toFixed(2)}
                    </p>
                  </div>
                </>
              ) : (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ height: "300px" }}
                >
                  <img
                    className="d-dark-none mt-5 position-sticky"
                    src={productEmpty_light}
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.5",
                    }}
                  />
                  <img
                    className="d-light-none mt-5 position-sticky"
                    src={productEmpty_dark}
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.5",
                    }}
                  />

                  <h5 className="text-muted mt-3" style={{ opacity: "0.5" }}>
                    No hay productos
                  </h5>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="border-translucent pb-6 mb-1">
            <div className="card mb-3 rounded-4 border-0 shadow-sm">
              <div className="card-body">
                <div className="row gx-3">
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="form-floating mb-3">
                      <input
                        className="form-control input-spin-none rounded-4"
                        id="floatingInput"
                        type="text"
                        {...form1.register("obs", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                      />
                      {form1.formState.errors?.obs && (
                        <code>{form1.formState.errors.obs.message}</code>
                      )}
                      <label htmlFor="floatingInput">Tipo</label>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="mb-3">
                      <div className="d-flex flex-wrap mb-2">
                        <h5 className="mb-0 text-body-highlight me-2">
                          Cliente
                        </h5>
                        <NavLink
                          className="fw-bold fs-9"
                          to={"/main/NuevoCliente"}
                        >
                          Nuevo cliente
                        </NavLink>
                      </div>
                      <Select
                        className="mb-0 mi-select mi-select-bordered"
                        classNamePrefix="rs"
                        styles={customStyles}
                        placeholder="Selecciona un cliente"
                        options={clientes}
                        value={
                          clientes.find(
                            (option) => option.value === form1.watch("idcont")
                          ) || null
                        }
                        {...form1.register("idcont", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idcont", event.value);
                        }}
                      />
                      {form1.formState.errors?.idcont && (
                        <code>{form1.formState.errors.idcont.message}</code>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="mb-1">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Condiciones de pago
                      </label>
                      <input
                        className="form-control input-spin-none rounded-4"
                        id="exampleFormControlInput"
                        type="text"
                        {...form1.register("garantia", {
                          maxLength: {
                            value: 255,
                            message: "Máximo 255 caracteres",
                          },
                        })}
                      />
                      {form1.formState.errors?.garantia && (
                        <code>{form1.formState.errors.garantia.message}</code>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="mb-1">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Tiempo de entrega
                      </label>
                      <input
                        className="form-control input-spin-none rounded-4"
                        id="exampleFormControlInput"
                        type="text"
                        {...form1.register("tiempoEntrega", {
                          maxLength: {
                            value: 255,
                            message: "Máximo 255 caracteres",
                          },
                        })}
                      />
                      {form1.formState.errors?.tiempoEntrega && (
                        <code>
                          {form1.formState.errors.tiempoEntrega.message}
                        </code>
                      )}
                    </div>
                  </div>
                  <div className="col-8 col-sm-6 col-xl-8">
                    <div className="mb-2">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Fecha expiración
                      </label>
                      <input
                        className="form-control rounded-4"
                        id="datepicker"
                        type="date"
                        {...form1.register("fecVencimiento", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                      />
                      {form1.formState.errors?.fecVencimiento && (
                        <code>
                          {form1.formState.errors.fecVencimiento.message}
                        </code>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-2">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Moneda
                      </label>
                      <select
                        className="form-select rounded-4"
                        value={form1.watch("idMoneda")}
                        {...form1.register("idMoneda", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idMoneda", event.target.value, {
                            shouldValidate: true,
                          });
                        }}
                      >
                        {moneda.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-2">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Tipo de pago{" "}
                      </label>
                      <Select
                        className="mb-1 mi-select mi-select-bordered"
                        classNamePrefix="rs"
                        styles={customStyles}
                        placeholder="Seleccionar"
                        options={tpago}
                        value={
                          tpago.find(
                            (option) => option.value === form1.watch("idTPago")
                          ) || null
                        }
                        {...form1.register("idTPago", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idTPago", event.value, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {form1.formState.errors?.idTPago && (
                        <code>{form1.formState.errors.idTPago.message}</code>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 mb-2">
                    <div className="mb-2">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Medio de pago{" "}
                      </label>
                      <Select
                        className="mb-1 mi-select mi-select-bordered"
                        classNamePrefix="rs"
                        placeholder="Seleccionar"
                        styles={customStyles}
                        options={mPago}
                        value={
                          mPago.find(
                            (option) =>
                              option.value === form1.watch("idMedioPago")
                          ) || null
                        }
                        {...form1.register("idMedioPago", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idMedioPago", event.value, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {form1.formState.errors?.idMedioPago && (
                        <code>
                          {form1.formState.errors.idMedioPago.message}
                        </code>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between border-top border-translucent border-dashed pt-4">
                  <h4 className="mb-0">Total :</h4>
                  <h4 className="mb-0">
                    {
                      moneda.find(
                        (mon) => mon.value === form1.getValues("idMoneda")
                      )?.label
                    }{" "}
                    {" " + parseFloat(stadicts.total).toFixed(2)}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="false"
        ref={modalConfiguracion}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <div className="modal-header border-0">
              <h3 className="modal-title " id="documentModalLabel">
                Configuración de cotizaciones
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h5 className="mb-3">Opciones generales</h5>

              <div className="p-3 border rounded-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    id="flexSwitchCheckChecked"
                    type="checkbox"
                    checked={igv}
                    onChange={() => {
                      setIgv(!igv);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckChecked"
                  >
                    Impuesto General a las Ventas (IGV)
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="documentModal"
        tabIndex="-1"
        aria-labelledby="documentModalLabel"
        aria-hidden="true"
        ref={modalClonar}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-5 p-3">
            {/* Header */}
            <div className="modal-header border-0">
              <h3 className="modal-title " id="documentModalLabel">
                Elija documento destino
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="list-group rounded-3">
                <label className="list-group-item d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center text-primary fw-bold">
                    <span className="far fa-file-alt text-secondary fs-4 me-4"></span>
                    Venta
                  </div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="docType"
                    value="venta"
                    checked={docType === "venta"}
                    onChange={(event) => {
                      setDocType(event.target.value);
                    }}
                  />
                </label>

                {/* Opción Cotización */}
                <label className="list-group-item d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center text-primary fw-bold">
                    <span className="far fa-file-archive text-secondary fs-4 me-4"></span>
                    Cotización
                  </div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="docType"
                    value="cotizacion"
                    checked={docType === "cotizacion"}
                    onChange={(event) => {
                      setDocType(event.target.value);
                    }}
                  />
                </label>

                {/* Opción Guía de Remisión */}
                <label className="list-group-item d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center text-primary fw-bold">
                    <span className="fas fa-caravan text-secondary fs-4 me-2"></span>
                    Guía de Remisión
                  </div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="docType"
                    value="guiaremision"
                    checked={docType === "guiaremision"}
                    onChange={(event) => {
                      setDocType(event.target.value);
                    }}
                  />
                </label>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-subtle-secondary rounded-4"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-subtle-primary rounded-4"
                onClick={() => {
                  clone();
                }}
              >
                Clonar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
